import { getStorageByIdFromState } from '@mimir/web/store/storeMisc';
import type { StorageProfile } from '@mimir/web/desktop/storageSettings';
import isEmpty from 'lodash/isEmpty';

export const hasSufficientStorageSettings = (profile: StorageProfile): { isSufficient: boolean, message: string | undefined } => {
  if (!profile.storageId) {
    return { isSufficient: false, message: undefined };
  }
  if (!getStorageByIdFromState(profile.storageId)) {
    return { isSufficient: false, message: 'Selected storage doesn\'t exist anymore! Please select a new one' };
  }
  return { isSufficient: !isEmpty(profile.downloadPath), message: undefined };
};
